import api from './axios';
import { Customer, StorageHistoryEntry } from '../types/customer';
import { ApiResponse, StorageListResponse } from '../types/storage';

interface CustomerListResponse extends ApiResponse {
  data?: Customer[];
}

interface CustomerResponse extends ApiResponse {
  data?: Customer;
}

interface HistoryListResponse extends ApiResponse {
  data?: StorageHistoryEntry[];
}

interface CustomerSearchParams {
  ad?: string | null;
  telefon?: string | null;
  plaka?: string | null;
  showDeleted?: boolean;
}

interface GetAllParams {
  showDeleted?: boolean;
}

export const customerApi = {
  getAll: (params?: GetAllParams) => api.get<CustomerListResponse>('/customers', { params }),
  getById: (id: string) => api.get<CustomerResponse>(`/customers/${id}`),
  search: (params: CustomerSearchParams) => api.get<CustomerListResponse>('/customers/search', { params }),
  create: (data: Partial<Customer>) => api.post<CustomerResponse>('/customers', data),
  update: (id: string, data: Partial<Customer>) => api.put<CustomerResponse>(`/customers/${id}`, data),
  delete: (id: string) => api.delete<CustomerResponse>(`/customers/${id}`),
  restore: (id: string) => api.post<CustomerResponse>(`/customers/${id}/restore`),
  getHistory: (id: string) => api.get<HistoryListResponse>(`/customers/${id}/history`),
  getUnlinked: (id: string) => api.get<StorageListResponse>(`/customers/${id}/unlinked`),
  linkStorage: (customerId: string, storageId: string) =>
    api.post<ApiResponse>(`/customers/${customerId}/link/${storageId}`),
};
